import { HttpInterceptorFn } from '@angular/common/http';
import { getTokenData } from './utility.service';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SCOPED_AUTH_SENTINEL_HEADER } from '../constants/common.const';
// import { switchMap } from 'rxjs';

const exeptAuthRequestUrl = ['me/google/token', 'assets', '42qpv4', 'oauth/token'];

// A background AI suggestion must never end the session (SPEC FR-10: "no blocking").
// The Bearer is still attached below — this list ONLY opts the URL out of the 401 auto-logout.
// Do NOT add this URL to exeptAuthRequestUrl above: that list strips the Bearer.
// The TicketCRM event card (SOL-1144 INC-020) is a read-only side panel of the event page, also shown
// to organizers: a TCS 401 there must not drop the whole cabinet session. Only this one TCS path.
const noAutoLogoutUrl = ['generative/report-filter-name', 'sold-out-ticketcrm-service/api/v1/bindings/event-card'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Sentinel check — a scoped interceptor or a scoped session service has already claimed this
  // request (owner / marketolog). Strip the marker and forward: no organizer Bearer, and
  // critically NO organizer auto-logout in the catchError below.
  if (req.headers.has(SCOPED_AUTH_SENTINEL_HEADER)) {
    return next(req.clone({ headers: req.headers.delete(SCOPED_AUTH_SENTINEL_HEADER) }));
  }

  const authService = inject(AuthService);
  const router = inject(Router);

  // if (exeptAuthRequestUrl.every(el => !req.url.includes(el))) {
  //   return authService.isValidToken().pipe(
  //     switchMap(isTokenValid => {
  //       if (isTokenValid) {
  //         const tokenData = JSON.parse(localStorage.getItem('tokenData')!);
  //         const clonedReq = req.clone({
  //           headers: req.headers.set('Authorization', 'Bearer ' + tokenData.token),
  //         });
  //         return next(clonedReq);
  //       } else {
  //         return next(req);
  //       }
  //     }),

  // }

  // return next(req);
  let authReq;
  // console.log(exeptAuthRequestUrl, req.url);
  if (exeptAuthRequestUrl.every(el => !req.url.includes(el))) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${getTokenData().token}`,
      },
    });
  }
  return next(authReq || req).pipe(
    catchError(err => {
      const skipAutoLogout = noAutoLogoutUrl.some(u => req.url.includes(u));
      if (err.status === 401 && !skipAutoLogout) {
        authService.logout();
        router.navigate(['/auth']);
      }
      return throwError(() => err);
    }),
  );
};
